<template>
  <card
    :id="card.id"
    :key="card.id"
    :title="card.title"
    :subtitle-regular="getUpdateTime.phrase"
    :subtitle-highlight="getUpdateTime.time"
    :class="{ 'card-disabled': card.disabled }"
  >
    <component
      :is="card.component.name"
      v-if="card.visible"
      :key="card.component.key"
      :content="card.component.content"
      @click="handleClick"
    />
    <infotip
      v-if="card.disabled"
      :id="card.id + '-disabled'"
      :key="card.id + '-infotip-disabled'"
      :text="card.disabledMessage ||
        'A funcionalidade está temporariamente em manutenção.'
      "
      :auto-open-on-first-days="false"
      :never-open-again-after-dismissed="false"
      :close-on-mouse-leave="true"
    />
  </card>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import CountIndicator from '../Widgets/CountIndicator.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CardPanicAlert',
  components: {
    card: Card,
    infotip: Infotip,
    'count-indicator': CountIndicator
  },
  computed: {
    ...mapGetters(['getUpdateTime']),
    ...mapGetters(['panicAlertsTotal']),
    card() {
      return {
        id: 'panicAlert',
        visible: true,
        disabled: false,
        title: 'Alertas',
        updateTimeVisible: true,
        component: {
          name: 'count-indicator',
          content: {
            number: this.panicAlertsTotal,
            text: '',
            color: 'red',
            icon: 'alert-emergency',
            action: 'panicAlert',
            sizeBig: true
          }
        }
      }
    }
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: '/panic-alert/search'
      })
    }
  }
}
</script>
